<div class="bc-work-item-widget">
  <app-chat-widget *ngIf="workItem.isChat()" [workItem]="workItem"></app-chat-widget>
  <app-chat-pin-invite-widget *ngIf="workItem.isChatPinInvite()" [workItem]="workItem"></app-chat-pin-invite-widget>
  <app-email-widget *ngIf="workItem.isEmail()" [workItem]="workItem"></app-email-widget>
  <app-email-compose *ngIf="workItem.isComposeEmail()" [workItem]="workItem"></app-email-compose>
  <app-lens-widget *ngIf="workItem.isLens()" [workItem]="workItem"></app-lens-widget>
  <app-text-chat-widget *ngIf="workItem.isMessage()" [workItem]="workItem"></app-text-chat-widget>
  <app-discussion-widget *ngIf="workItem.isDiscussion()" [workItem]="workItem"></app-discussion-widget>
  <app-genesys-chat-widget *ngIf="workItem.isGenesysChat()" [workItem]="workItem"></app-genesys-chat-widget>
  <app-genesys-email-widget *ngIf="workItem.isGenesysEmail()" [workItem]="workItem"></app-genesys-email-widget>
</div>
